import React from 'react';
import { Box, InputLabel, TextField, TextFieldProps } from '@mui/material';
import WcnWarningIcon from './Icon/WcnWarningIcon.tsx';

export interface WcnTextFieldProps extends Omit<TextFieldProps, 'color'> {
    warning?: boolean;
    warningText?: string;
}

const WcnTextField: React.FC<WcnTextFieldProps> = ({
    label,
    InputLabelProps: inputLabelProps,
    sx,
    warning,
    warningText,
    helperText,
    ...props
}) => {
    const resolvedHelperText = warning && !props.error ? (warningText ?? helperText) : helperText;

    return (
        <Box className="wcn-text-field-wrapper" sx={sx}>
            {label && (
                <InputLabel
                    shrink
                    required={props.required}
                    disabled={props.disabled}
                    error={props.error}
                    htmlFor={props.id}
                    className="wcn-text-field-label"
                    {...inputLabelProps}
                >
                    {label}
                </InputLabel>
            )}
            <Box className="wcn-text-field-input-wrapper">
                <TextField
                    {...props}
                    label={undefined}
                    variant="outlined"
                    fullWidth
                    helperText={resolvedHelperText}
                    className={`wcn-text-field ${warning && !props.error ? 'wcn-input--warning' : ''} ${props.className ?? ''}`}
                    FormHelperTextProps={{
                        ...props.FormHelperTextProps,
                        className: `${warning && !props.error ? 'wcn-input-helper--warning' : ''} ${props.FormHelperTextProps?.className ?? ''}`
                    }}
                />
                {warning && !props.error && <WcnWarningIcon />}
            </Box>
        </Box>
    );
};

WcnTextField.displayName = 'WcnTextField';

export default WcnTextField;
